import React from "react";
import "./Links.css"; // Ajoutez un fichier CSS pour les styles spécifiques, si nécessaire.
import SEO from "../SEO/SEO";

const Links = () => {
  const links = [
    {
      label: "Paris Airports",
      url: "https://www.aeroportsdeparis.fr/ADP/en-GB/Passagers/",
      description: "Explore flights, services, and traveler information for Paris' main airports, including Charles de Gaulle and Orly.",
    },
    {
      label: "Beauvais Airports",
      url: "https://www.aeroportbeauvais.com/index.php?lang=eng",
      description: "Get details about flights, parking, and amenities at Beauvais Airport, a key hub for low-cost airlines.",
    },
    {
      label: "Château de Chantilly",
      url: "https://www.chateaudechantilly.com",
      description: "Discover the Château de Chantilly, a stunning historic castle surrounded by beautiful gardens and art collections.",
    },
    {
      label: "Château de Versailles",
      url: "https://www.chateauversailles.fr/en/",
      description: "Visit the iconic Palace of Versailles, known for its opulent architecture, Hall of Mirrors, and expansive gardens.",
    },
    {
      label: "Château de Chenonceau",
      url: "https://www.chenonceau.com/",
      description: "Tour the Château de Chenonceau, a magnificent castle spanning the River Cher, famous for its history and beauty.",
    },
    {
      label: "Château Amboise",
      url: "https://www.chateau-amboise.com",
      description: "Experience the Château Amboise, a royal residence offering panoramic views of the Loire Valley.",
    },
    {
      label: "Office de Tourisme de Paris",
      url: "https://www.parisbienvenue.com/",
      description: "Find official tourist information for Paris, including attractions, events, and practical advice for visitors.",
    },
    {
      label: "Musée de Louvre",
      url: "https://www.louvre.fr/llv/commun/home_flash.jsp",
      description: "Explore the Louvre, the world's largest art museum, home to the Mona Lisa and countless masterpieces.",
    },
    {
      label: "Musée d'Orsay",
      url: "https://www.musee-orsay.fr/ORSAY/orsaygb/HTML.NSF/By+Filename/mosimple+index?OpenDocument",
      description: "Discover the Musée d'Orsay, a renowned museum showcasing Impressionist and Post-Impressionist masterpieces.",
    },
    {
      label: "Fondation Monet",
      url: "https://www.fondation-monet.com/uk/sommaire/index.html",
      description: "Visit Monet's home and gardens in Giverny, an enchanting site that inspired the artist's famous water lilies.",
    },
    {
      label: "Vélo à Paris",
      url: "https://www.veloparis.com",
      description: "Plan your cycling adventure in Paris with bike rental options, routes, and safety tips.",
    },
    {
      label: "Disneyland Paris",
      url: "https://www.disneylandparis.co.uk/index.xhtml",
      description: "Experience the magic of Disneyland Paris, a premier destination for family fun and entertainment.",
    },
  ];
  

  return (
<div>
  <SEO
      title="Useful Links - RS Transports"
      description="Discover a curated list of useful links for travelers, including Paris airports, tourist attractions like the Château de Versailles and the Louvre, and transportation options. Plan your journey with ease using these trusted resources."
      keywords="useful links, Paris airports, tourist attractions, Château de Versailles, Louvre, Disneyland Paris, RS Transports, travel resources, airport guides"
    />
    <section id="links" className="py-5">

  <div className="container">
        <h1 className="text-center mb-5">Useful Links</h1>
        <div className="row">
          {links.map((link, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card shadow-sm h-100">
                <div className="card-body d-flex flex-column justify-content-between">
                  <h2 className="card-title">{link.label}</h2>
                  <p className="card-text">{link.description}</p>
                  <a
                    href={link.url}
                    title={link.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success mt-3"
                  >
                    {link.label}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</div>
  );
};

export default Links;
